import { apiService, apiAService } from "../apiService";
import ftURLConfig from "../../../config/toc/ftURLConfig";
import { jwtToken } from "../../types/genericTypes";
import { IPayIn, IPayOut, ITransferStatus } from "./../../toc/fundTransfer/ftInterfaces";
import { IModifyPayout } from "../../types/components/fundTransfer/ftTypes";
import LoginService from "../login/loginService";

let pToken: jwtToken | null = LoginService.pToken,
	userID = pToken ? pToken.username : null;

//after redirect reinstate pToken with parsed jwt token
const pTokenCheck = (paramChk?: keyof jwtToken) => {
	if (!pToken) {
		pToken = LoginService.pToken;
		userID = pToken ? pToken.username : null;
	}
	return paramChk && pToken ? pToken[paramChk] : pToken;
};
// Add fund Equity-Limits - rms sublimits
export const AEqFundLimit = (callback: CallableFunction) => {
	if (pTokenCheck("accType") !== "CO") {
		apiService(
			{
				url: ftURLConfig.eqLimit + userID,
				method: "GET",
				authType: "authtoken"
			},
			callback
		);
	}
};

export const AaeqFundLimit = async ()=>{
	if (pTokenCheck("accType") !== "CO") {
		return await apiAService({
				url: ftURLConfig.eqLimit ,
				method: "GET",
				authType: "authtoken"
			});
	}
}

//Get Max Payout Amount
export const AEqMaxPayout = (callback: CallableFunction) => {
	if (pTokenCheck("accType") !== "CO") {
		apiService(
			{
				url: ftURLConfig.eqMaxPayout + "/" + userID,
				method: "GET",
				authType: "authtoken"
			},
			callback
		);
	}
};

// Add fund Equity-BankDetils
export const AEqFundBankDetils = (callback: CallableFunction) => {
	if (pTokenCheck("accType") !== "CO") {
		apiService(
			{
				url: ftURLConfig.eqBankDetails + userID,
				method: "GET",
				authType: "authtoken"
			},
			callback
		);
	}
};

// Add fund commoditity-Limits
export const ACommFundLimit = (callback: CallableFunction) => {
	if (pTokenCheck("accType") !== "EQ") {
		apiService(
			{
				url: ftURLConfig.commodityLimit + userID,
				method: "GET",
				authType: "authtoken"
			},
			callback
		);
	}
};

// Add fund commoditity-BankDetils
export const ACommFundBankDetils = (callback: CallableFunction) => {
	if (pTokenCheck("accType") !== "CO") {
		apiService(
			{
				url: ftURLConfig.commodityBankDetails + userID,
				method: "GET",
				authType: "authtoken"
			},
			callback
		);
	}
};

//Payout with
//{userId}?rTyp=PAYOUT
export const APayoutBankDetails = (callback: CallableFunction) => {
	if (pTokenCheck("accType") !== "CO") {
		apiService(
			{
				url: ftURLConfig.payout.bankdetails + userID + "?rTyp=PAYOUT",
				method: "GET",
				authType: "authtoken"
			},
			callback
		);
	}
};
//commodity acc
//Payout with
//{userId}?rTyp=PAYOUT
export const AFTCommPayoutBankDetails = (callback: CallableFunction) => {
	if (pTokenCheck("accType") !== "EQ") {
		apiService(
			{
				url: ftURLConfig.payout.bankdetailsComm + userID + "?rTyp=PAYOUT",
				method: "GET",
				authType: "authtoken"
			},
			callback
		);
	}
};

//Payin  submit button api
export const AFtAddfundIn = (callback: CallableFunction, payinBody: IPayIn) => {
	if (pTokenCheck("accType") !== "CO") {
		apiService(
			{
				// order/details/1111?nOID=111
				url: ftURLConfig.payin.paymentgatewayurl + userID,
				method: "POST",
				authType: "authtoken",
				body: payinBody
			},
			callback
		);
	}
};

//Payout  submit button api
export const AFtWidthrawFundEq = (callback: CallableFunction, payOutBody: IPayOut) => {
	if (pTokenCheck("accType") !== "CO") {
		apiService(
			{
				url: ftURLConfig.payout.addpayoutEq + userID,
				method: "POST",
				authType: "authtoken",
				body: payOutBody
			},
			callback
		);
	}
};

export const AFtWidthrawFundComm = (callback: CallableFunction, payOutBody: IPayOut) => {
	if (pTokenCheck("accType") !== "EQ") {
		apiService(
			{
				url: ftURLConfig.payout.addpayoutComm + userID,
				method: "POST",
				authType: "authtoken",
				body: payOutBody
			},
			callback
		);
	}
};

// Fund Transfer History - Equity
export const ATransferHisEqPayin = (callback: CallableFunction, transferHisBody: ITransferStatus) => {
	if (pTokenCheck("accType") !== "CO") {
		apiService(
			{
				url:
					ftURLConfig.history.transferstatusEqPayIn +
					userID +
					"?rTyp=PAYIN" +
					"&sDt=" +
					transferHisBody.sDt +
					"&eDt=" +
					transferHisBody.eDt,
				method: "GET",
				authType: "authtoken"
			},
			callback
		);
	}
};

// Fund Transfer History - Equity Payout
export const ATransferHisEqPayOut = (callback: CallableFunction, transferHisBody: ITransferStatus) => {
	if (pTokenCheck("accType") !== "CO") {
		apiService(
			{
				url:
					ftURLConfig.history.transferstatusEqPayOut +
					userID +
					"?rTyp=PAYOUT" +
					"&sDt=" +
					transferHisBody.sDt +
					"&eDt=" +
					transferHisBody.eDt,
				method: "GET",
				authType: "authtoken"
			},
			callback
		);
	}
};

// Fund Transfer History - Commodity
export const ATransferHisComm = (callback: CallableFunction, transferHisBody: ITransferStatus) => {
	if (pTokenCheck("accType") !== "EQ") {
		apiService(
			{
				url:
					ftURLConfig.history.transferstatusComm +
					userID +
					"?rTyp=" +
					transferHisBody.rTyp +
					"&sDt=" +
					transferHisBody.sDt +
					"&eDt=" +
					transferHisBody.eDt,
				method: "GET",
				authType: "authtoken"
			},
			callback
		);
	}
};
//verify pay in transaction
export const AFTVerifyPayin = (
	callback: CallableFunction,
	verifyPayIn: {
		instNo: string;
	}
) => {
	if (pTokenCheck()) {
		apiService(
			{
				url: ftURLConfig.payin.verifyPayIn + userID,
				method: "PUT",
				authType: "authtoken",
				body: verifyPayIn
			},
			callback
		);
	}
};

//modify payout

export const AFTModifyPayout = (callback: CallableFunction, modifyPayout: IModifyPayout, accType: string) => {
	if (pTokenCheck()) {
		apiService(
			{
				url: accType === "CO" ? ftURLConfig.payout.modifyPayoutEComm + userID : ftURLConfig.payout.modifyPayoutEq + userID,
				method: "PUT",
				authType: "authtoken",
				body: modifyPayout
			},
			callback
		);
	}
};
//cancel payout
export const AFTCancelPayout = (
	callback: CallableFunction,
	cancelPayout: {
		instNo: string;
	},
	accType: string
) => {
	if (pTokenCheck()) {
		apiService(
			{
				url: accType === "CO" ? ftURLConfig.payout.cancelPayoutEComm + userID : ftURLConfig.payout.cancelPayoutEq + userID,
				method: "DELETE",
				authType: "authtoken",
				body: cancelPayout
			},
			callback
		);
	}
};

//intent status
export const AFTPayInUPIIntentStatus = (callback: CallableFunction, pgrefno: string) => {
	if (pTokenCheck("accType") !== "CO") {
		apiService(
			{
				url: ftURLConfig.payin.upistatus + userID + "?pgrefno=" + pgrefno,
				method: "GET",
				authType: "authtoken"
			},
			callback
		);
	}
};
// To get PayInUrl for a particular client

export const AFTCommFetchPayInURL = (callback: CallableFunction) => {
	if (pTokenCheck("accType") !== "EQ") {
		apiService(
			{
				url: ftURLConfig.payin.commPayInURL + userID,
				method: "GET",
				authType: "authtoken"
			},
			callback
		);
	}
};
// 
